module.exports = __webpack_public_path__ + "img/MINUS.39844b32.svg";